import Session from '@/components/Session';

import Icon_01 from '@/assets/images/icon_01.svg';
import Icon_02 from '@/assets/images/icon_02.svg';
import Icon_03 from '@/assets/images/icon_03.svg';
import Icon_04 from '@/assets/images/icon_04.svg';

export default function Services() {
    return (
        <>
            <Session className='services'>
                <div className='service'>
                    <div className='icons'>
                        <img
                            className='icon'
                            src={Icon_01.src}
                        />
                    </div>
                    <div className='name'>No Contract Needed, Stay From 30 Days</div>
                </div>
                <div className='service'>
                    <div className='icons'>
                        <img
                            className='icon'
                            src={Icon_02.src}
                        />
                    </div>
                    <div className='name'>No Booking Fee, No Agent Fee</div>
                </div>
                <div className='service'>
                    <div className='icons'>
                        <img
                            className='icon'
                            src={Icon_03.src}
                        />
                    </div>
                    <div className='name'>Fully Furnished Room, Move in Ready</div>
                </div>
            </Session>
        </>
    );
}
